var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 440 440",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220,421.7991572075213C307.5079007355923,421.9423063599666,384.82576301178915,365.56533448364553,412.2879115815566,282.4781298203393C440.1896176633167,198.06103631503532,414.32012078007665,103.80173894725502,342.36664366981387,51.576763984129826C270.5137771150084,-0.5751862420291047,173.00042040490808,4.264753822258847,101.50705795578249,56.90845686690036C31.430088749603243,108.50920735312548,2.76004659573686,199.08162742783142,29.6385770006572,281.8521757354102C56.53105132643644,364.66566336882505,132.92957665160822,421.65672369922544,220,421.7991572075213",
    fill: "#0EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1998cff23ca6144a2a1c6f247521cdd3.svg";
export { ForwardRef as ReactComponent };